import React from 'react';
import { ArrowLeft, MapPin, User } from 'lucide-react';
interface Props {
  onBack?: () => void;
}
export function MatchConnections({
  onBack
}: Props) {
  const connections = [{
    id: '1',
    name: 'Marco Rossi',
    role: 'Policy Advisor',
    company: 'FAO',
    theme: 'AI Governance',
    initials: 'MR',
    meetingSpot: 'Sala Ulivo, Piano 1'
  }, {
    id: '2',
    name: 'Sarah Jenkins',
    role: 'Sustainability Director',
    company: 'Barilla',
    theme: 'Climate Finance',
    initials: 'SJ',
    meetingSpot: 'Sala Quercia, Piano 2'
  }];
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] px-6 pt-6 pb-24 overflow-y-auto" data-id="element-189">
      {/* Header Area */}
      <div className="mb-6" data-id="element-190">
        <h2 className="text-[18px] font-medium text-white tracking-tight" data-id="element-191">
          I tuoi match
        </h2>
        <p className="text-[13px] text-[#888888] mt-1" data-id="element-192">
          {connections.length} persone da incontrare al Summit
        </p>
      </div>

      {/* Connections List */}
      <div className="flex flex-col gap-4" data-id="element-193">
        {connections.map(conn => <div key={conn.id} className="bg-[#141414] border border-[#2A2A2A] rounded-xl p-4 flex flex-col gap-4" data-id="element-194">
            <div className="flex items-start gap-4" data-id="element-195">
              <div className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center flex-shrink-0" data-id="element-196">
                <span className="text-[15px] font-medium text-white" data-id="element-197">
                  {conn.initials}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-198">
                <h3 className="text-[16px] font-medium text-white truncate tracking-tight" data-id="element-199">
                  {conn.name}
                </h3>
                <p className="text-[13px] text-[#888888] truncate" data-id="element-200">
                  {conn.role} @ {conn.company}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-1" data-id="element-201">
              <MapPin className="w-3.5 h-3.5 text-[#C5D82D] flex-shrink-0" data-id="element-202" />
              <span className="text-[12px] text-[#888888]" data-id="element-203">
                {conn.meetingSpot}
              </span>
            </div>

            <div className="flex items-center justify-between mt-2" data-id="element-204">
              <span className="bg-[rgba(255,143,0,0.12)] rounded-full px-3 py-1 text-[11px] font-medium text-white" data-id="element-205">
                {conn.theme}
              </span>
              <button className="flex items-center gap-1.5 bg-transparent border border-[#C5D82D] text-white px-4 py-1.5 rounded-full text-[12px] font-medium active:scale-95 transition-all duration-200" data-id="element-206">
                <MapPin className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-207" />
                Incontra
              </button>
            </div>
          </div>)}
      </div>
    </div>;
}